import { render, staticRenderFns } from "./addAdmissionGuide.vue?vue&type=template&id=328cb5c7&scoped=true&"
import script from "./addAdmissionGuide.vue?vue&type=script&lang=js&"
export * from "./addAdmissionGuide.vue?vue&type=script&lang=js&"
import style0 from "./addAdmissionGuide.vue?vue&type=style&index=0&id=328cb5c7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328cb5c7",
  null
  
)

export default component.exports